var path = '/app/components/ui/student-avatar/student-avatar.html';
var html = "<div class=avatar-container ng-class=\"{ 'inline': $ctrl.inline }\"> <div class=avatar-container-body> <img ng-src={{$ctrl.thumbs[$root.$currentUser.avatar]}} width=\"{{ $ctrl.lg ? '200' : '150' }}\"/> <span class=student-name>{{ $root.$currentUser.name }}</span> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/student-avatar/student-avatar.html
// module id = 184
// module chunks = 0